import React from 'react';

const ClientsPage = () => {
  return (
    <div className="card">
      <div className="row" style={{ justifyContent: 'space-between' }}>
        <h3>Clients / Retailers</h3>
        <button className="secondary">Export</button>
      </div>
      <div className="filters">
        <div className="filter-row">
          <div><label>Search</label><input placeholder="Client name, phone" /></div>
          <div><label>Credit Status</label><select><option>All</option><option>In Limit</option><option>Overdue</option></select></div>
          <div><label>Tier</label><select><option>All</option><option>Tier 1</option><option>Tier 2</option></select></div>
        </div>
      </div>
      <table className="table">
        <thead>
          <tr>
            <th>Client</th>
            <th>Company</th>
            <th>Orders</th>
            <th>Credit Limit</th>
            <th>Outstanding</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>Retailer A</td><td>Alpha Traders</td><td>12</td><td>{'\u20B9'}2,00,000</td><td>{'\u20B9'}40,000</td></tr>
          <tr><td>Retailer B</td><td>Urban Hub</td><td>8</td><td>{'\u20B9'}1,50,000</td><td>{'\u20B9'}25,000</td></tr>
        </tbody>
      </table>
    </div>
  );
};

export default ClientsPage;
